export default __webpack_public_path__ + "static/media/pioneer_logo_black_1.589fa247.png";